import { useState } from 'react';
import { supabase } from '../supabase.ts';

export function SignIn() {
  const [email, setEmail] = useState('');
  const [sent, setSent] = useState(false);
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState<string | null>(null);

  async function send(e: React.FormEvent) {
    e.preventDefault();
    setBusy(true);
    setError(null);
    const { error: authError } = await supabase.auth.signInWithOtp({
      email: email.trim(),
      options: { emailRedirectTo: window.location.origin },
    });
    setBusy(false);
    if (authError) setError(authError.message);
    else setSent(true);
  }

  if (sent) {
    return (
      <div className="signin">
        <h1>Check your email.</h1>
        <p>
          There's a link on its way to <strong>{email}</strong>. Open it on this device and
          you're in — no password to remember.
        </p>
        <button type="button" className="chip" onClick={() => setSent(false)}>
          Use a different address
        </button>
      </div>
    );
  }

  return (
    <form className="signin" onSubmit={send}>
      <h1>slate</h1>
      <p>
        The books, series and films you're quietly waiting on — so you don't have to hold them
        in your head.
      </p>
      <input
        className="field"
        type="email"
        required
        value={email}
        onChange={(e) => setEmail(e.target.value)}
        placeholder="you@example.com"
        aria-label="Email address"
        autoComplete="email"
      />
      <button className="primary-btn" type="submit" disabled={busy || !email.trim()}>
        {busy ? 'Sending…' : 'Email me a link'}
      </button>
      {/* States what went wrong and what to do, in the interface's voice. */}
      {error && <p className="notice">{error}</p>}
    </form>
  );
}
